export const hexOpacity = (opacity) => {
    const hex = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
    ];
    if (opacity > 1)
        opacity /= 100;
    opacity *= 255;
    const a = Math.floor(opacity / 16);
    const b = Math.round((opacity % 16) / 16);
    return hex[a] + hex[b];
};
export const hexWithOpacity = (hex, opacity) => `${hex}${hexOpacity(opacity)}`;
